<template>
  <div class="Footer">
    <div class="banner-sec" style="display: flex; justify-content: center;" v-if="banner.link">
        <a :href="banner.link" target="_blank" rel="noopener noreferrer" class="banner">
          <img :src="urlpath.url() +
            '/get-banner-image/' +
            banner.image
            " alt="banner" />
        </a>
      </div>

    <div class="foo-cont">
      <div class="menu-i">
        <a href="/">INICIO</a>
        <a href="/conocenos">CONÓCENOS</a>
        <a href="/blog">BLOG</a>
        <a href="/colaboradores">COLABORADORES</a>
      </div>
      <a href="" class="logo">
        <img src="../../assets/foodie-l.png" alt="logo" />
      </a>
      <div class="polices-c">
        <div class="col-1">
          <a href="/politicas-de-privacidad">Política de privacidad</a>
          <a href="">Newsletter</a>
        </div>
        <p>Copyright© {{ year }} Derechos Reservados</p>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import { mapActions } from "vuex";
let urlpath = require("../../global/url");
export default {
  data() {
    return {
      year: null,
      urlpath,
    }
  },
  created(){
    this.getAllInfoBnr("banner");
  },
  computed:{
    banner() {
      let arr = this.$store.getters["banner/data"];
      if(!Array.isArray(arr)) return arr
      let option = 'footer'
      let blog = arr.filter((arr) => arr.section == "footer");
      return blog.length>0 ? blog[0] : [];
    },
  },
  methods:{
    ...mapActions("banner", ["getAllInfoBnr"]),
  },
  mounted() {
    this.year = dayjs().format('YYYY');
  },
};
</script>
<style>

/**banner */
.banner-sec {
  background-color: white !important;
  width: 92.754vw;
  height: auto;
  margin: auto;
}

.banner-sec img {
  width: 100%;
}

.foo-cont {
  width: 89.855vw;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12.077vw 0;
  border-top: 0.725vw solid #a6a6a6;
}

.menu-i {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.menu-i a,
.polices-c a,
.polices-c p {
  font-size: 4vw !important;
  padding: 0px 2.415vw;
  line-height: 7vw;
  font-family: var(--RedHat);
  color: black;
  font-weight: 600;
}

.foo-cont .logo {
  margin: 10.87vw 0;
}

.foo-cont .logo img {
  width: 72.464vw;
  height: auto;
}

.foo-cont .polices-c {
  display: flex;
  flex-direction: column;
  align-items: center;
}

@media (min-width: 768px) {

  .menu-i a,
  .polices-c a,
  .polices-c p {
    font-size: 0.797vw !important;
    padding: 0px 1.302vw;
    line-height: 0.797vw;
  }

  .foo-cont {
    width: 89.855vw;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2.604vw 0;
    border-top: 0.26vw solid #a6a6a6;
  }

  .foo-cont .logo {
    margin: 2.344vw 0;
  }

  .foo-cont .logo img {
    width: 15.625vw;
    height: auto;
  }
}
</style>